import { Cookies } from 'react-cookie';

/** react-cookie와 api 인터셉터가 공유하는 쿠키 인스턴스 */
export const cookies = new Cookies();
